import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../services/firebase';

export default class ChatRow extends Component {
    constructor(props) {
		super(props)
		this.state = {
            userName: "",
            userImageUrl: "",
        };
	}

    componentDidMount() {
        db.ref('users').child(this.props.userId).on('value', (snapshot) => {
            if (snapshot.exists() === false) {
                return
            }

            let user = snapshot.val()
            let imageUrl = user.imageUrl ? user.imageUrl : "person.png"

            this.setState({
                userName: user.name,
                userImageUrl: imageUrl,
            })
        })
    }

    render() {
        return (
            <Link to={"/chat/" + (this.props.chatId)} onClick={this.props.onClick}>
                <div>
                    {this.state.userName}
                </div>
                <img src={this.state.userImageUrl} alt="avatar" width="50"/>
            </Link>
        )
    }
}